import { StyleSheet } from '@react-pdf/renderer'

export const styles = StyleSheet.create({
  header: {
    marginTop: '-0.5cm',
    height: '2cm',
    display: 'flex',
    flexDirection: 'row',
    marginRight: '1cm',
    marginBottom: '0.5cm',
  },
  logoContainer: {
    width: '2cm',
    height: '2cm',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 2,
    overflow: 'hidden',
  },
  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  headerTitle: {
    marginLeft: '0.5cm',
    justifyContent: 'center',
  },
  titleText: {
    fontSize: 9,
    fontWeight: 'thin',
    color: '#858484',
  },
  chip: {
    fontSize: 12,
    paddingVertical: 2,
    paddingHorizontal: 6,
    marginBottom: 8,
    borderRadius: 2,
    backgroundColor: '#858484',
    color: '#fff',
    alignSelf: 'flex-start',
  },
  section: {
    width: '18cm',
  },
  summarySection: {
    width: '14cm',
    marginHorizontal: '2cm',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderBottomWidth: 0.5,
    borderColor: '#dcdcdc',
    height: '5cm',
    paddingVertical: '0.25cm',
    paddingHorizontal: '0.25cm',
    paddingLeft: 0,
    marginBottom: '0.25cm',
  },
  tableRow: {
    flexDirection: 'row',
  },
  colLabel: {
    width: '7cm',
    marginLeft: '0.5cm',
    paddingTop: '0.25cm',
    fontSize: 12,
  },
  colLabelSmall: {
    width: '6cm',
    marginLeft: '0.5cm',
    paddingTop: '0.25cm',
    fontSize: 12,
  },
  image: {
    width: '4cm',
    height: '4cm',
    objectFit: 'cover',
    borderRadius: 2,
    marginLeft: '0.25cm',
    overflow: 'hidden',
  },
  tableCol: {
    width: '70%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingBottom: 6,
  },
  tableCell: {
    marginTop: 6,
    fontSize: 10,
  },
  mergedCell: {
    borderBottom: 0,
    paddingBottom: 0,
  },
  spacedRow: {
    marginTop: 16,
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1.5cm',
  },
  coverTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: '0.2cm',
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    paddingBottom: '0.2cm',
  },
  label: {
    fontSize: 10,
    fontWeight: 'medium',
  },
  subTitle: {
    color: '#5c5a5a',
    fontSize: 10,
  },
  indicator: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 3,
  },
})

export const rotorStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: '0.7in 0.7in 0.383in 0.7in', // 1,778cm 1,778cm 0,973cm 1,778cm
    backgroundColor: '#FFFFFF',
    justifyContent: 'space-between',
  },
  list: {
    flexDirection: 'column',
    width: '100%',
  },
  item: {
    flexDirection: 'row',
    gap: 4,
    paddingVertical: '0.2cm',
    paddingLeft: '0.2cm',
    borderBottom: '0.75 solid #000000',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  imageContainer: {
    maxWidth: '5.9cm',
    minWidth: '5.9cm',
    height: '5.9cm',
  },
  logo: {
    width: '0.91cm',
    marginRight: 6,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 4,
    minHeight: '0.7cm',
    gap: 4,
  },
  space: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  divider: {
    width: '100%',
    borderBottom: '0.75 dotted #B8B8B8',
  },
  document: {
    fontSize: 24,
    fontWeight: 'semibold',
    fontFamily: 'Inter',
  },
  header: {
    flexDirection: 'column',
    justifyContent: 'flex-end',
    width: '100%',
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: 'semibold',
    fontFamily: 'Inter',
    paddingLeft: 6,
    paddingBottom: '0.25cm',
    borderBottom: '1.5 solid #000000',
  },
  headerSubtitle: {
    fontSize: 14,
    fontWeight: 'medium',
    fontFamily: 'Inter',
    paddingLeft: 6,
    paddingVertical: '0.25cm',
    borderBottom: '0.75 solid #000000',
  },
  headerDescription: {
    fontSize: 11,
    fontWeight: 'light',
    fontFamily: 'Inter',
    fontStyle: 'italic',
    textAlign: 'justify',
    padding: '0.5cm',
    borderBottom: '0.75 solid #000000',
    maxHeight: '4.4cm',
    overflow: 'hidden',
  },
  title: {
    fontSize: 11,
    fontWeight: 'medium',
    fontFamily: 'Inter',
    textOverflow: 'ellipsis',
    flexWrap: 'wrap',
    width: '10cm',
    paddingVertical: 4,
  },
  text: {
    fontSize: 9,
    fontWeight: 'light',
    fontFamily: 'Inter',
  },
  boldText: {
    fontSize: 9,
    fontWeight: 'medium',
    fontFamily: 'Inter',
  },
  reemployment: {
    fontSize: 11,
    fontWeight: 'light',
    fontFamily: 'Inter',
    letterSpacing: '-1.75pt',
  },
  reference: {
    fontSize: 7,
    fontWeight: 'light',
    fontFamily: 'Inter',
    marginLeft: 4,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '0.4cm',
  },
  footerText: {
    fontSize: 8.5,
    fontWeight: 'light',
    fontFamily: 'Inter',
  },
  footerReference: {
    fontSize: 8.5,
    fontWeight: 'medium',
    fontFamily: 'Inter',
  },
})

export const rotorReferencesStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '0.7in 0.7in 0.383in 0.7in', // 1,778cm 1,778cm 0,973cm 1,778cm
    backgroundColor: '#FFFFFF',
  },
  list: {
    flexDirection: 'column',
    width: '100%',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 2,
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  imageContainer: {
    maxWidth: '3.016cm',
    minWidth: '3.016cm',
    maxHeight: '3.016cm',
    paddingRight: 2,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    maxHeight: '3.2cm',
    paddingLeft: 2,
  },
  titleContainer: {
    width: '100%',
  },
  title: {
    fontSize: 11,
    fontWeight: 'medium',
    fontFamily: 'Inter',
    borderBottom: '0.75 solid #000000',
  },
  text: {
    fontSize: 9,
    fontWeight: 'light',
    fontFamily: 'Inter',
  },
  centered: {
    fontSize: 9,
    fontWeight: 'light',
    fontFamily: 'Inter',
    textAlign: 'center',
  },
  bold: {
    fontSize: 9,
    fontWeight: 'medium',
    fontFamily: 'Inter',
  },
  italic: {
    fontSize: 9,
    fontWeight: 'light',
    fontFamily: 'Inter',
    fontStyle: 'italic',
  },
  code: {
    width: '1.6cm',
  },
  designation: {
    width: '5.4cm',
  },
  unit: {
    width: '1.2cm',
  },
  dimensions: {
    width: '2cm',
  },
  logo: {
    width: '0.91cm',
    marginRight: 6,
  },
})
